<template>
  <div id="sticky-nav"
       class="
          uk-width-full
          uk-height-auto
          uk-position-z-index
        "
       :class="{
         'uk-height-1-1': submenuOpen,
         'submenu-open': submenuOpen
      }"
       uk-sticky="offset: 0px"
  >
    <div class="uk-height-1-1" id="nav">
      <div class="uk-navbar-left uk-flex-around">
        <div class="uk-display-inline-block uk-float-left">
          <PlayPauseIcon />
          <a href="/" class="uk-navbar-item uk-display-inline">
            Jason de Ridder
          </a>
        </div>
        <Hamburger
          class="uk-navbar-toggle uk-float-right uk-hidden@m"
          @toggle="toggleSubmenu"
        />

        <!-- Medium and up menu -->
        <router-link to="/tarieven" class="uk-navbar-item uk-visible@m opaque-7">
          Tarieven
        </router-link>
        <router-link to="/voice-over-aanvragen" class="uk-navbar-item uk-visible@m opaque-7">
          Voice Over aanvragen
        </router-link>
        <router-link to="/tevredenheid" class="uk-navbar-item uk-visible@m opaque-7">
          Tevredenheid
        </router-link>
        <router-link to="/veelgestelde-vragen" class="uk-navbar-item uk-visible@m opaque-7">
          Veelgestelde vragen
        </router-link>
        <router-link to="/contact" class="uk-navbar-item uk-visible@m opaque-7">
          Contact
        </router-link>

      </div>

      <!-- Medium and down (hamburger) menu -->
      <div class="uk-animation-slide-top-medium uk-height-1-1 mobile-menu hidden@m"
           :class="{'uk-hidden': !submenuOpen}">
        <router-link to="/tarieven" class="uk-navbar-item">Tarieven</router-link>
        <router-link to="/voice-over-aanvragen" class="uk-navbar-item">
          Voice Over aanvragen
        </router-link>
        <router-link to="/tevredenheid" class="uk-navbar-item">Tevredenheid</router-link>
        <router-link to="/veelgestelde-vragen" class="uk-navbar-item">Veelgestelde vragen
        </router-link>
        <router-link to="/contact" class="uk-navbar-item">Contact</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Hamburger from '@/components/Hamburger.vue';
import PlayPauseIcon from './PlayPauseIcon.vue';

export default {
  name: 'MainNav.vue',
  components: {
    PlayPauseIcon,
    Hamburger,
  },
  methods: {
    toggleSubmenu(isOpen) {
      this.submenuOpen = isOpen;
    },
  },
  data() {
    return {
      submenuOpen: false,
    };
  },
};
</script>
